import { FaEnvelope, FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiCopy } from "react-icons/fi";
import { toast } from "sonner";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const ShareActivityModal: React.FC<{
  activityUrl: string;
  isLoading: boolean;
}> = ({ activityUrl, isLoading }) => {
  return (
    <div className="text-center ">
      <h3 className="text-lg font-semibold mb-6 text-gray800">
        Share with friends
      </h3>
      <div className="flex justify-center gap-6 mb-6 text-xl text-gray-600">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            activityUrl
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF className="hover:text-blue-600 transition" />
        </a>
        <a
          href={`https://x.com/intent/tweet?url=${encodeURIComponent(
            activityUrl
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaXTwitter className="hover:text-black transition" />
        </a>
        <a
          href="https://www.instagram.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="hover:text-pink-500 transition" />
        </a>
        <a
          href={`mailto:?subject=Check this out&body=${encodeURIComponent(
            activityUrl
          )}`}
        >
          <FaEnvelope className="hover:text-red-500 transition" />
        </a>
      </div>

      <div className="border border-[#E2E4E9] rounded-lg px-4 py-2 ">
        <h2 className="text-left text-sm font-semibold text-gray800 mb-1">
          ACTIVITY URL
        </h2>
        <div className="flex items-center justify-between ">
          {isLoading ? (
            <p className=" text-sm text-gray800 mr-2">Generating link...</p>
          ) : (
            <span className="truncate text-gray800 text-sm mr-2">
              {activityUrl}
            </span>
          )}

          <CopyToClipboard
            text={activityUrl}
            onCopy={() => toast.success("Link copied to clipboard!")}
          >
            <FiCopy className="text-lg text-gray600 hover:text-gray500 cursor-pointer" />
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};
